import './Video.css'

interface VideoInfos {
  title: string
  url: string
}

interface IProps {
  figureLegend: JSX.Element
  videos: VideoInfos[]
}

function Video (props: IProps) {
  return (
    <div className="modelling-vids">
      <div className="vids">
        {props.videos.map((video, index) => (
          <iframe
            key={index}
            title={video.title}
            width="560"
            height="315"
            src={video.url}
            frameBorder={0}
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups"
          ></iframe>
        ))}
      </div>
      <div className="vids-caption">{props.figureLegend}</div>
    </div>
  )
}

export default Video
